import { render, staticRenderFns } from "./facilities-section.vue?vue&type=template&id=3819252c&scoped=true"
import script from "./facilities-section.vue?vue&type=script&lang=js"
export * from "./facilities-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819252c",
  null
  
)

export default component.exports